import { variables, colors } from "../../common/styles";

const { sideBarWidth } = variables;

export default (theme) => ({
    fullHeight: {
        height: "100%",
        minHeight: "460px",
        width: "100%"
    },
    progressContainer: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    },
    tableContainer: {
        height: "100%",
        width: `calc(100% - ${sideBarWidth + theme.spacing(3)})`
    },
    controlBtn: {
        background: "#eee",
        margin: "1rem",
        borderRadius: ".3rem",
        border: `1px solid ${colors.lightGrey}`
    },
    stepperControl: {
        display: "flex",
        height: "80px",
        justifyContent: "center",
        background: "#eee"
    },
    dataList: {
        height: "calc(100% - 80px)"
    },
    stepper: {
        backgroundColor: "transparent"
    },
    highlightDisabled: {
    border: '1px solid red !important',  // override default grey border
    borderRadius: '.3rem'
}

});
